import { changePhoneClicksFilter } from 'actions/phoneClicks'
import React from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state, props) {
    const { filters, isFetching, counts } = state.phoneClicks
    const filter = filters[props.filterId]
    const count = filter && counts[filter.searchKey]
    return {
        filter,
        count,
        isFetching,
    }
}

export default connect(mapStateToProps, { changeFilter: changePhoneClicksFilter })
